<template>
  <div class="box gray-box gray-box-bg">
    <div class="box-body inner-title">
      <el-row class="box-header">
        <el-col :span="18">
          <h3>商品总计</h3>
        </el-col>
      </el-row>
      <el-select @change="selectBusiness" v-if="groupList" v-model="currentBusiness" placeholder="选择商家" style="width: 100%;margin-bottom: 10px;">
        <el-option
          v-for="(item, key) in groupList"
          :key="key"
          :label="key"
          :value="key">
        </el-option>
      </el-select>
      <div class="content">
        <div v-if="!groupList">
          <el-row class="empty-tip">
            <el-col :span="24">
              购物车内还没有添加商品……
            </el-col>
          </el-row>
        </div>
        <div v-if="groupList && !currentBusiness">
          <el-row class="empty-tip">
            <el-col :span="24">
              您还没有选择商家。
            </el-col>
          </el-row>
        </div>
        <div v-if="copyGoodsList.length">
          <el-row class="total-sum">
            <el-col :span="12">
              商品金额
            </el-col>
            <el-col :span="12" class="text-right amount">
              {{amount | currency(taskInfo.currency_symbol)}}
            </el-col>
          </el-row>
        </div>
        <el-button :disabled="!copyGoodsList.length || !currentBusiness" v-if="!useRate" class="block" type="info" @click="next()" :loading="loading">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import YueDanIpt from '../../../components/YueDanIpt'
import api from '../../../services/api.js'
import {API_HOST} from '../../../services/constant.js'
let _ = require('lodash')

export default {
  name: 'OrderTotal',
  props: ['goodsList', 'useRate', 'groupList','isAIRetreave'],
  components: {
    YueDanIpt: YueDanIpt
  },
  computed: {
    taskInfo () {
      return this.$store.state.taskInfo
    }
  },
  data () {
    return {
      businesses: [],
      total_rate_amount: null,
      loading: false,
      dialogFormVisible: false,
      errors: null,
      isEmptyErrors: true,
      copyGoodsList: [],
      form: {
        tax_amount: 0,
        transport_amount: 0,
        other_amount: 0
      },
      business: null,
      bussinessList: null,
      tax_amount: 0,
      transport_amount: 0,
      other_amount: 0,
      amount: 0,
      total_amount: 0,
      currentBusiness: null,
      rules: {
        tax_amount: [
          { required: true, message: '消费税是必填项', trigger: 'blur' }
        ],
        transport_amount: [
          { required: true, message: '商家运费是必填项', trigger: 'blur' }
        ]
      },
      isSingle: false
    }
  },
  created () {
    if (this.taskInfo) {
      this.$store.commit('clearTaskInfo')
    }
    this.init()
    this.cal()
    if (this.$route.fullPath.indexOf('buyer') > -1) {
      this.isSingle = true
    } else {
      this.isSingle = false
    }
    this.currentBusiness = this.$route.query.business_name
  },
  methods: {
    selectBusiness (key) {
      if (this.groupList) {
        let list = this.groupList[key] || []
        this.copyGoodsList = []
        _.each(list, item => {
          if (!item.deleted) {
            item.cart_id = item.id
            this.copyGoodsList.push(item)
            this.business = item
          }
        })
        if (this.copyGoodsList && this.copyGoodsList.length) {
          let goods = this.copyGoodsList[0]
          this.taskInfo.currency = goods.currency
          this.taskInfo.currency_symbol = goods.currency_symbol
        }
        this.$forceUpdate()
      } else {
        this.copyGoodsList = []
      }
    },
    async initEditOrder () {
      let orderId = this.$route.query.order_id
      if (orderId && !this.taskInfo.id) {
        let res = await api.getOrderById(this, {
          order_id: orderId
        })
        res = res.body.result
        res.address_info = res.address
        res.conditions = JSON.parse(res.conditions)
        res.coupon = JSON.parse(res.coupon)
        await this.getGroupBussinessList(res)
        _.each(res.goods_list, goods => {
          goods.business_name = res.business_name
          goods.business_id = res.business_id
          goods.business_website = res.business_website
        })
        Object.assign(this.taskInfo, res)
        this.$store.commit('updateTaskInfo', this.taskInfo)
      }
    },
    async getGroupBussinessList (data) {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
      if (this.bussinessList[data.business_id]) {
        data.business_name = this.bussinessList[data.business_id][0].name
        data.business_website = this.bussinessList[data.business_id][0].website
      }
    },
    cal () {
      this.amount = 0
      _.each(this.copyGoodsList, goods => {
        this.amount = Number(this.amount) + Number(goods.discounted_price) * goods.number
      })

      this.total_amount = Number(this.amount) + Number(this.tax_amount) + Number(this.transport_amount)
      if (this.useRate) {
        this.total_amount += Number(this.other_amount)
        this.total_rate_amount = this.total_amount * this.taskInfo.conditions.rate
      }
    },
    init () {
      this.errors = null
      this.isEmptyErrors = true
      this.form = {
        tax_amount: 0,
        // tax_amount: this.taskInfo.tax_amount || 0,
        transport_amount: this.taskInfo.transport_amount || 0,
        other_amount: this.taskInfo.other_amount || 0
      }
      this.tax_amount = 0,
      // this.tax_amount = this.taskInfo.tax_amount || 0,
      this.transport_amount = this.taskInfo.transport_amount || 0
      this.other_amount = this.taskInfo.other_amount || 0
      this.copyGoodsList = this.goodsList || []
    },
    /*next(){
      this.$emit('gotominiprogram',this.business.business_id)
    }*/
    next () {
      this.taskInfo.business=this.business
      this.taskInfo.business_id = this.taskInfo.business.business_id
      this.taskInfo.business_name = this.taskInfo.business.business_name
      this.taskInfo.business_website = this.taskInfo.business.business_website
      this.taskInfo.goods_list = this.copyGoodsList
      this.taskInfo.fee_adjustment_list = []
      this.$store.commit('updateTaskInfo', this.taskInfo)
      this.$router.push({ path: '/publish_task/address',
        query: {
          business_name: this.currentBusiness,
          isAIRetreave:this.isAIRetreave
        }})
    }
  },
  watch: {
    goodsList: {
      handler: function (val, oldVal) {
        this.copyGoodsList = this.goodsList || []
        this.cal()
      },
      deep: true
    },
    copyGoodsList: {
      handler: function (val, oldVal) {
        this.cal()
      },
      deep: true
    },
    groupList: {
      handler: function (val) {
        /*if (val && Object.keys(val).length == 1) {
          this.currentBusiness = Object.keys(val)[0]
          this.$router.push({ path: '/publish_task/cart',
            query: {
              business_name: this.currentBusiness
            }})
        }*/
        this.selectBusiness(this.currentBusiness)
        this.cal()
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.total-sum {
  padding: 10px 0;
  margin-bottom: 20px;
  color: #686B73;
  border-bottom: 2px solid #DEE2EC;
  line-height: 33px;

  .amount {
    font-size: 24px;
  }
}

.empty-tip {
  color: #686B73;
  padding: 10px 0 25px;
  margin-bottom: 20px;
  border-bottom: 2px solid #DEE2EC;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/CartTotal.vue